import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { DolPopover } from '@doltech/ui/lib/figma/Popover/DolPopover';
import { IconSystemV2InterfaceEssentialQuestionList } from '@doltech/icons/SystemV2/IconSystemV2InterfaceEssentialQuestionList';
import { ButtonIconPrimaryGeneral } from '@doltech/ui/lib/figma/Button/ButtonIconPrimaryGeneral/ButtonIconPrimaryGeneral';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { shadows } from '@doltech/ui/lib/figma/shadows';

const Container = styled.div``;
const Tooltip = styled.div`
  background-color: ${colorsV2.white100};
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid ${colorsV2.gray20};
  box-shadow: ${shadows.zIndex3};
`;

interface ButtonIconDictationQuestionListProps {
  htmlId?: string;
  className?: string;
  onClick?: () => void;
}

export const ButtonIconDictationQuestionList = (props: ButtonIconDictationQuestionListProps) => {
  const { htmlId, className, onClick } = props;

  return (
    <Container id={htmlId} className={cl('button-icon-dictation-question-list', className)}>
      <DolPopover
        placement="bottom-start"
        trigger="hover"
        overlayClassName="un-styled no-arrow custom-inner-content"
        content={
          <Tooltip>
            <ResponsiveTypography.Paragraph variant="regular/12-20" color="black100">
              Danh sách câu hỏi
            </ResponsiveTypography.Paragraph>
          </Tooltip>
        }
      >
        <ButtonIconPrimaryGeneral
          type="white"
          buttonStyle="outline"
          icon={<IconSystemV2InterfaceEssentialQuestionList />}
          onClick={onClick}
        />
      </DolPopover>
    </Container>
  );
};
